<template>
  <v-container>
    <mensajeSistema />

    <template>
      <v-row>
        <v-col
          cols="12"
          v-if="listaAlumnoAreaCompetencia.length !== 0 && !loading"
        >
          <v-expansion-panels accordion focusable>
            <!-- multiple -->
            <v-expansion-panel
              v-for="itemParent in listaAlumnoAreaCompetencia"
              :key="itemParent.id_grado_adm"
            >
              <v-expansion-panel-header class="px-2 pa-0 yellow darken-1">
                <v-row no-gutters class="d-flex">
                  <v-col cols="4" align-self="center">
                    <v-avatar size="36px">
                      <img
                        alt="Avatar"
                        src="https://cdn-icons-png.flaticon.com/512/4641/4641058.png"
                      />
                    </v-avatar>
                    <b> {{ itemParent.desc_grado }} </b>
                  </v-col>

                  <v-col cols="8" class="text--secondary" align-self="center">
                    <v-fade-transition leave-absolute>
                      <v-row no-gutters style="width: 100%">
                        <v-col cols="6">
                          Niveles: {{ itemParent.desc_nivel }}
                        </v-col>
                      </v-row>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <br />
                <v-expansion-panels
                  v-model="panelAlumnosNotas"
                  accordion
                  focusable
                >
                  <!-- multiple -->
                  <v-expansion-panel
                    v-for="itemAlumnos in itemParent.grados_estudiante"
                    :key="itemAlumnos.id_alumno"
                  >
                    <v-expansion-panel-header
                      class="px-2 pa-0"
                      color="yellow lighten-5"
                    >
                      <!-- @click="resetAlerts()" -->
                      <v-row no-gutters>
                        <v-col cols="4">
                          <v-avatar size="36px">
                            <img
                              alt="Avatar"
                              src="https://static.vecteezy.com/system/resources/previews/038/042/984/non_2x/graduate-student-avatar-icon-in-colors-vector.jpg"
                            />
                          </v-avatar>
                          <b>{{ itemAlumnos.nombres_completos }}</b>
                          <small style="color: red">
                            {{
                              !itemAlumnos.estado_alumno
                                ? "(Alumno Evaluado)"
                                : ""
                            }}</small
                          >
                        </v-col>
                        <v-col cols="8" class="text--secondary customrow">
                          <v-fade-transition leave-absolute>
                            <v-row
                              justify="space-around"
                              no-gutters
                              style="width: 100%"
                            >
                              <v-col cols="6">
                                Grado: {{ itemAlumnos.desc_grado }}
                              </v-col>
                              <v-col cols="auto">
                                Situacion final:
                                <v-chip
                                  class="text-uppercase"
                                  label
                                  :class="
                                    itemAlumnos.criterio_estado_final ==
                                    'PROMOVIDO'
                                      ? 'color_aprobado'
                                      : itemAlumnos.criterio_estado_final ==
                                        'PERMANENCIA'
                                      ? 'color_desaprobado'
                                      : itemAlumnos.criterio_estado_final ==
                                        'RECUPERACIÓN PEDAGÓGICA'
                                      ? 'color_recuperacion'
                                      : ''
                                  "
                                  small
                                >
                                  {{ itemAlumnos.criterio_estado_final }}
                                </v-chip>
                              </v-col>
                            </v-row>
                          </v-fade-transition>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content active-class class="expaco">
                      <v-overlay
                        :value="!itemAlumnos.estado_alumno"
                        absolute
                        color="white"
                        opacity="0.5"
                      ></v-overlay>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead style="background-color: #efefef">
                                  <tr>
                                    <th
                                      class="text-start"
                                      v-for="head in headerSelectorComp"
                                      :style="{
                                        'background-color': '#efefef',
                                      }"
                                      :key="head.valor"
                                    >
                                      {{ head.text }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody
                                  class="custom-tbody"
                                  v-if="
                                    itemAlumnos.competencias_recuperar.length !=
                                    0
                                  "
                                >
                                  <tr
                                    v-for="competencia in itemAlumnos.competencias_recuperar"
                                    :key="competencia.id_competencia"
                                  >
                                    <td>
                                      {{ competencia.dec_area_adm }}
                                    </td>
                                    <td>
                                      {{ competencia.competencia }}
                                    </td>

                                    <td>
                                      <v-menu
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                      >
                                        <!-- <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-text-field
                                                  class="text-caption"
                                                  :value="
                                                    dateRangeText(
                                                      competencia.periodo
                                                    )
                                                  "
                                                  label="Periodo de evaluación"
                                                  prepend-icon="mdi-calendar"
                                                  readonly
                                                  hide-details
                                                  v-bind="attrs"
                                                  v-on="on"
                                                ></v-text-field>
                                              </template> -->
                                        <v-date-picker
                                          v-model="competencia.periodo"
                                          no-title
                                          scrollable
                                          range
                                          @change="
                                            validarRangoFechaClient(
                                              $event,
                                              competencia
                                            )
                                          "
                                        >
                                        </v-date-picker>
                                      </v-menu>
                                    </td>
                                    <td>
                                      <b style="color: red">
                                        {{
                                          convertirNumAliteral(
                                            competencia.nota_modificada
                                          )
                                        }}
                                      </b>
                                    </td>
                                    <td>
                                      <v-select
                                        :disabled="!competencia.estado"
                                        v-model="
                                          competencia.nota_cargo_modificada
                                        "
                                        @change="
                                          modifyNota(
                                            $event,
                                            competencia,
                                            itemAlumnos,
                                            'Cargo'
                                          )
                                        "
                                        hide-details
                                        small-chips
                                        :items="competencia.notas_asignar"
                                        item-value="valor"
                                        item-text="desc"
                                      >
                                        <template v-slot:label>
                                          <p style="font-size: 14px">
                                            Califica
                                          </p>
                                        </template>
                                      </v-select>
                                    </td>

                                    <td>
                                      <!-- <v-tooltip top color="#1b1b1b">
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                                  v-on="on"
                                                  class="btn_eliminar px-0 mx-0"
                                                  fab
                                                  x-small
                                                  @click="
                                                    removerNuevaNota(
                                                      itemAlumnos,
                                                      competencia,
                                                      indx
                                                    )
                                                  "
                                                >
                                                  <v-icon small
                                                    >fa-trash-alt</v-icon
                                                  >
                                                </v-btn>
                                        </template>
                                        <span>Borrar registro</span>
                                      </v-tooltip> -->
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-else>
                                  <tr style="width: 100%">
                                    <th
                                      colspan="4"
                                      class="text-center text-caption"
                                    >
                                      No existe información
                                    </th>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>

                          <v-col cols="12" class="text-center">
                            <v-scale-transition>
                              <v-btn
                                class="animate__animated animate__pulse animate__infinite"
                                v-if="validaCompetenciasEvaluadas(itemAlumnos)"
                                @click="
                                  EvaluarGenerarHistoricoCursoCargo(itemAlumnos)
                                "
                                small
                                color="warning"
                                >Listo para evaluar
                                <v-icon small right>fas fa-check</v-icon></v-btn
                              >
                              <v-btn
                                @click="actualizarCompetenciasCargo(itemAlumnos)"
                                v-else
                                small
                                color="primary"
                                >Guardar cambios
                                <v-icon small right>fas fa-save</v-icon>
                              </v-btn>
                            </v-scale-transition>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col
          cols="12"
          v-else-if="listaAlumnoAreaCompetencia.length == 0 && loading"
          v-for="num in 3"
          :key="num"
          class="mb-0 pb-0"
        >
          <v-skeleton-loader
            class="skeletonRecuperacion"
            max-height="200"
            type="text"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col
          v-else
          class="d-flex justify-center align-center"
          style="background: #f4f4f4"
        >
          No hay resultados <strong class="ml-1"> disponibles</strong>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations } from "vuex";
export default {
  props: ["tabPosition"],
  data: () => ({
    datoLogin: sessionStorage,
    listaAlumnoAreaCompetencia: [],
    listaAlumnoAreaCompetenciaOrigen: [],
    loading: false,
    panelAlumnosNotas: [],
    altoTablas: [],
    headerSelectorComp: [
      {
        text: "Area",
        value: "area",
        class: "secondary black--text",
      },
      {
        text: "Competecia",
        value: "competencia",
        class: "secondary black--text",
      },
      {
        text: "Periodos",
        value: "periodos",
        class: "secondary black--text",
      },
      {
        text: "Nota referencial",
        value: "notas_vacacional",
        class: "secondary black--text",
      },
      {
        text: "Establecer nota",
        value: "notas_asignar",
        class: "secondary black--text",
      },

      { text: "Acciones", value: "action", class: "secondary black--text" },
    ],
    // niveles: [],
    // grados: [],
    // secciones: [],
    // nivelSelected: -1,
    // gradoSelected: -1,
    // seccionSelected: -1,
    // id_colegio: parseInt(sessionStorage.getItem("id_colegio")),
    // id_ano_lectivo: parseInt(sessionStorage.getItem("id_ano_lectivo")),
    // headers: [
    //   {
    //     text: "Alumno",
    //     value: "nombre_alumno",
    //     class: "secondary black--text",
    //   },
    //   { text: "Nivel", value: "", class: "secondary black--text" },
    //   { text: "Grado", value: "", class: "secondary black--text" },
    //   { text: "Cursos a cargo", value: "", class: "secondary black--text" },
    // ],
  }),
  mounted() {
    this.loadMain();
    // let id_colegio = sessionStorage.getItem("id_colegio");
    // let id_ano_lectivo = sessionStorage.getItem("id_ano_lectivo");
    // this.getNiveles(id_ano_lectivo, id_colegio);
  },
  watch: {
    tabPosition(valor) {
      if (valor == 2) {
        console.log(valor);     
        this.loadMain();
      }
    },
  },
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),
    /*_____________________________________
    │   * Metodo añadir notas a editar     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    loadMain() {
      this.listarCursosAcargo();
    },
    /*___________________________________________________________
    │   * Método para convertir nota numerica a nota literal     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    convertirNumAliteral(notaNum) {
      switch (notaNum) {
        case 4:
          return "AD";
        case 3:
          return "A";
        case 2:
          return "B";
        case 1:
          return "C";
        default:
          return "";
      }
    },
    /*________________________________________________________________
    │   * Método para obtener el valor o nota de las competencias     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerNotaCompSaved(valor, notasrecuperadas, competencias) {
      // competencias.forEach((e) => {
      //   let datosRec = notasrecuperadas.filter(
      //     (el) => el.id_competencia == e.ID_COMPETENCIA
      //   );
      //   if (datosRec.length > 0) {
      //     if (datosRec[0].nota_cargo_modificada != null) {
      //       e.NIVEL_LOGRO_COMPETENCIA = datosRec[0].nota_cargo_modificada;
      //     }
      //   }
      // });

      console.log({ competencias });

      return valor;
      //   ? Math.round(competencias[index - 1].NIVEL_LOGRO_COMPETENCIA)
      //   : null;
    },
    /*__________________________________________________________________________________________________
    │   * Metodo guardar y actualizar competencias selecionar por docente para posterior evaluación     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async actualizarCompetenciasCargo(datosEstudianteActual) {      

      console.log({ datosEstudianteActual });

      for (let e of datosEstudianteActual.competencias_recuperar) {
        e.isSavedCargo = true;
      }

      // datosEstudianteActual.isActiveTable = true;

      try {
        // eslint-disable-next-line no-unused-vars
        const { data } = await axios.put(
          `/cierreanio/cursosacargo/updateCursosCargoCompetencias/`,
          datosEstudianteActual
        );

        // if (data) {
        this.setEnviarMens({
          tipo: "S",
          mensaje: `Competencias calificadas para evaluar`,
          tiempo: 3000,
        });
        // }
        // this.itemsDocente = data;
      } catch (error) {
        console.error(error);
      }
    },
    /*_____________________________________
    │   * Metodo añadir notas a editar     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async listarCursosAcargo() {
      const id_colegio = this.datoLogin.id_colegio;

      try {
        const { data } = await axios.get(
          `/cierreanio/cursosacargo/listarAlumnosCursosCargo/${id_colegio}`
        );

        const agrupadosPorGrado = Object.values(
          data.reduce((grupo, estudiante) => {
            const { id_grado_adm, desc_grado, desc_nivel } = estudiante;
            grupo[id_grado_adm] = grupo[id_grado_adm]
              ? grupo[id_grado_adm]
              : { id_grado_adm, desc_nivel, desc_grado, grados_estudiante: [] };

            estudiante.competencias_recuperar =
              estudiante.competencias_recuperar == null
                ? []
                : estudiante.competencias_recuperar;

            if (estudiante.competencias_recuperar.length > 0) {
              estudiante.areas_estudiante.forEach((e) => {
                estudiante.competencias_recuperar.forEach((u) => {
                  if (u.nota_cargo_modificada != null) {
                    e.nivel_logro_competencias_area.forEach((i) => {
                      if (i.ID_COMPETENCIA == u.id_competencia) {
                        i.NIVEL_LOGRO_COMPETENCIA = u.nota_cargo_modificada;
                      }
                    });
                  }
                });
              });
            }

            grupo[id_grado_adm].grados_estudiante.push(estudiante);
            return grupo;
          }, {})
        );

        console.log({ agrupadosPorGrado });

        this.listaAlumnoAreaCompetenciaOrigen = agrupadosPorGrado;
        this.listaAlumnoAreaCompetencia = agrupadosPorGrado;
      } catch (error) {
        console.error();
      }
    },
    /*___________________________________________________________________
    │   * Metodo evaluar y generar historico de notas recuperativas      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async EvaluarGenerarHistoricoCursoCargo(datosEstudianteActual) {
      datosEstudianteActual.estado_alumno = false;

      try {
        // eslint-disable-next-line no-unused-vars
        const { data } = await axios.post(
          `/cierreanio/cursosacargo/updateAlumnosGenerarHistoricoCursosACargo/`,
          datosEstudianteActual
        );
        this.setEnviarMens({
          tipo: "S",
          mensaje: `Estudiante fue evaluado en el periodo de cursos a cargo`,
          tiempo: 3000,
        });
      } catch (error) {
        console.error(error);
      }
    },
    /*_________________________________________________________________
    │   * Metodo obtener el titulo de la competencia en el tooltip     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerDesComp(data) {
      if (data != undefined) {
        return data.DESCRIPCION_COMPETENCIA;
      }
    },
    /*___________________________________________________
    │   * Metodo modificar notas alumnos recuperados     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async modifyNota(valor_nuevo, filas_actual, estudianteData, modulo) {
      filas_actual.isSavedCargo = false;
      const areas = estudianteData.areas_estudiante;
      areas
        .filter((e) => e.id_area_adm == filas_actual.id_area_adm)[0]
        .nivel_logro_competencias_area.filter(
          (e) => e.ID_COMPETENCIA == filas_actual.id_competencia
        )[0].NIVEL_LOGRO_COMPETENCIA = valor_nuevo;

      try {
        let data = {
          id_ano_lectivo_actual: parseInt(this.datoLogin.id_ano_lectivo),
          id_colegio: parseInt(this.datoLogin.id_colegio),
          modulo: modulo,
          estudiantes: [estudianteData],
        };

        // const response = respuesta;
        const response = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/actualizarAlumnosRecuperacion",
          data
        );

        if (response.data.MSG) {
          const condicionAreaNueva =
            response.data.DATOS[0].areas_estudiante.reduce(
              (acc, condicionNueva) => {
                acc[condicionNueva.id_area_adm] = condicionNueva;
                return acc;
              },
              {}
            );

          estudianteData.areas_estudiante = estudianteData.areas_estudiante.map(
            (condicionActual) => {
              return condicionAreaNueva[condicionActual.id_area_adm]
                ? {
                    ...condicionActual,
                    ...condicionAreaNueva[condicionActual.id_area_adm],
                  }
                : condicionActual;
            }
          );

          estudianteData.criterio_estado_final =
            response.data.DATOS[0].criterio_estado_final;
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Algo salió mal, revisa la configuracion previa`,
            tiempo: 3000,
          });
        }
      } catch (error) {
        console.log(error);
      }
      // finally {
      //   this.getAlumnosRecuperados(false);
      // }
    },
    /*_________________________________________
    │   * Metodo validacion de competencias    │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    validaCompetenciasEvaluadas(estudianteData) {
      if (estudianteData.competencias_recuperar.length != 0) {
        // console.log("RAST", estudianteData.competencias_recuperar);

        // const validaTabla = estudianteData.isActiveTable;&& validaTabla
        // eslint-disable-next-line no-unused-vars
        const estadoAlumno = estudianteData.estado_alumno;
        const valida = estudianteData.competencias_recuperar.filter(
          (el) => el.nota_modificada == null || el.isSavedCargo == false
        ).length;

        if (valida === 0) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>
<style scoped>
.customrow {
  display: flex;
  align-items: center;
}
</style>